var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutube = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.8,210.6l100.1,57l-100.1,57h0V210.6z M504.3,256c0,137.1-111.2,248.3-248.3,248.3S7.7,393.1,7.7,256 S118.9,7.7,256,7.7S504.3,118.9,504.3,256z M439.7,360.5c8-30.1,8-92.8,8-92.8s0-62.7-8-92.8c-4.4-16.6-17.4-29.7-33.9-34.1 c-29.9-8.1-149.8-8.1-149.8-8.1s-119.9,0-149.8,8.1c-16.5,4.4-29.5,17.5-33.9,34.1c-8,30.1-8,92.8-8,92.8s0,62.7,8,92.8 c4.4,16.6,17.4,29.1,33.9,33.5c29.9,8.1,149.8,8.1,149.8,8.1s119.9,0,149.8-8.1C422.3,389.6,435.2,377,439.7,360.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Youtube.32d6b11c1e4e82904d95ab423cadbd05.svg";